import { render, staticRenderFns } from "./SurveyOverviewUser.vue?vue&type=template&id=54aa4648"
import script from "./SurveyOverviewUser.vue?vue&type=script&lang=js"
export * from "./SurveyOverviewUser.vue?vue&type=script&lang=js"
import style0 from "./SurveyOverviewUser.vue?vue&type=style&index=0&id=54aa4648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports